import { useTranslation } from 'react-i18next'
import { Autocomplete, TextField } from '@mui/material'
import { PLACE_FOUND_OPTIONS } from '@/components/forms'

type ResidenceSelectProps = {
  value?: string
  onChange: (value: string | undefined) => void
}

export const ResidenceSelect = ({
  value,
  onChange,
}: ResidenceSelectProps): JSX.Element => {
  const { t } = useTranslation('forms')

  return (
    <Autocomplete
      options={PLACE_FOUND_OPTIONS.map((o) => ({
        label: o.name,
        value: o.value,
      }))}
      renderInput={(params) => (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <TextField {...params} label={t('placeholders.residence')} />
      )}
      value={
        value !== undefined
          ? {
              label: value,
              value,
            }
          : null
      }
      onChange={(_event, option) => {
        onChange(option ? option.label : undefined)
      }}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      sx={{ width: 240 }}
    />
  )
}
